module.exports = __webpack_public_path__ + "img/18.2f7c2087.jpg";